import React, { useEffect, useState } from "react";
import {
  GetReceiptVoucherList,
  GetReceiptVoucherById,
  ReceiptVoucherUpdate,
  ReceiptVoucherCreate,
  ReceiptVoucherDelete,
  ApproveSalesVoucherList,
  DivisionList,
  ApproveSolistapi,
  ApproveIndentlistapi,
  ApproveProformaInvoiceList,
  getAllTransporter,
  GetApprovedPOs as fetchpos,
  ApproveReceiptVoucher,
  GenerateReceiptVoucherNo,
  BankDetailList,
} from "../../../Services/Services";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Typography,
  Checkbox,
  Autocomplete,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Chip,
  Collapse,
  Divider,
  Menu,
} from "@mui/material";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { generateReceiptPdf } from "../Accounts/ReceiptVoucherPrint";
import config from "../../../config";
import InfiniteScroll from "react-infinite-scroll-component";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import dayjs from "dayjs";

const ReceiptVoucher = () => {
  // ===== States =====
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({ from: "", to: "" });
  const [selectingDate, setSelectingDate] = useState(null);
  const dateInputRef = React.useRef(null);
  // ⭐ ADD THESE TWO NEW STATES
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [receiptVoucher, setReceiptVoucher] = useState([]);
  const [purchaseLists, setPurchaseLists] = useState([]);
  const [transporterLists, setTransporterLists] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [rows, setRows] = useState([blankRow()]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewData, setViewData] = useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [PurchaseToApprove, setPurchaseToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);

  const [voucherType, setVoucherType] = useState("advance"); // default type
  const [selectedAdvance, setSelectedAdvance] = useState(null);
  const [selectedSale, setSelectedSale] = useState(null);
  const [saleList, setSaleList] = useState([]); // sale list from API
  const [project, setProject] = useState("");
  const [debitor, setDebitor] = useState("");
  const [amount, setAmount] = useState("");
  const [bankDetails, setBankDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [filters, setFilters] = useState({
    receipt_number: "",
    project: "",
    pi_no: "",
    sales_number: "",
    status: "Pending",
    date_range: "today",
  });

  const [expandedReceipt, setExpandedReceipt] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // ===== Initial Data Fetch =====
  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchVouchers(1, true, filters);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange]);

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  const fetchVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters
  ) => {
    const apiFilters = {
      receipt_number: filterValues.receipt_number,
      project: filterValues.project,
      pi_no: filterValues.pi_no,
      sales_number: filterValues.sales_number,
      status: filterValues.status,

      // ⭐ Date Range filters added:
      date_range: filterValues.date_range,
      from_date: customDateRange.from || "",
      to_date: customDateRange.to || "",
    };

    const data = await GetReceiptVoucherList(apiFilters, pageNum);

    if (reset || pageNum === 1) {
      setReceiptVoucher(
        Array.isArray(data) ? data.results : data.results || []
      );
    } else {
      setReceiptVoucher((prev) => [
        ...prev,
        ...(Array.isArray(data) ? data.results : data.results || []),
      ]);
    }

    setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
    setPage(pageNum);
  };

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVouchers(nextPage);
  };

  const fetchAllData = async () => {
    try {
      const [transporter, purchase, bank] = await Promise.all([
        getAllTransporter(),
        ApproveProformaInvoiceList(),
        BankDetailList(),
      ]);

      setTransporterLists(
        Array.isArray(transporter) ? transporter : transporter?.results || []
      );
      setPurchaseLists(
        Array.isArray(purchase) ? purchase : purchase?.results || []
      );
      setBankDetails(Array.isArray(bank) ? bank : bank?.results || []);
    } catch (error) {
      console.error("Data fetch error:", error);
      toast.error("Error fetching initial data");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // ===== Form Utilities =====
  function blankRow() {
    return {
      receipt_voucher_no: "",
      receipt_number: "",
      project: "",
      party: "",
      invoice_number: "",
      amount: "",
      attachment: "",
      payment_mode: "",
      bank: "",
      invoice_date: "",
      narration: "",
      proforma_invoice: "",
      description: "",
      cheque_no: "",
      sales_voucher: "",
      voucher_type: "",
    };
  }

  const handleRowChange = (index, e) => {
    const { name, value, files } = e.target;
    const updated = [...rows];
    updated[index][name] = name === "attachment" ? files[0] : value;
    setRows(updated);
  };

  const addRow = () => setRows([...rows, blankRow()]);
  const removeRow = (index) => setRows(rows.filter((_, i) => i !== index));

  // ===== Modal Handlers =====
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setRows([blankRow()]);
    setOpen(false);
  };

  useEffect(() => {
    const fetchSaleList = async () => {
      try {
        const data = await ApproveSalesVoucherList(); // implement this API call
        setSaleList(Array.isArray(data) ? data : data?.results || []);
      } catch (error) {
        console.error("Failed to fetch sale list", error);
      }
    };
    fetchSaleList();
  }, []);

  useEffect(() => {
    const fetchAdvanceList = async () => {
      const data = await ApproveProformaInvoiceList();
      setPurchaseLists(Array.isArray(data) ? data : data?.results || []);
    };
    fetchAdvanceList();
  }, []);

  const fetchNextPvNo = async () => {
    const data = await GenerateReceiptVoucherNo();
    if (data && data.data.receipt_voucher_no) {
      setRows((prev) => {
        const updated = [...prev];
        // sirf first row ka voucher no set karo
        if (updated.length > 0) {
          updated[0] = {
            ...updated[0],
            receipt_number: data.data.receipt_voucher_no,
          };
        }
        return updated;
      });
    }
  };

  const handleEditClick = async (id) => {
    const data = await GetReceiptVoucherById(id);
    if (data) {
      setEditFormData(data);
      setEditModalOpen(true);
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleView = (voucher) => {
    setViewData(voucher);
    setViewModalOpen(true);
  };
  const userId = Number(localStorage.getItem("user_id"));

  // ===== Submit Handlers =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    const timestamp = Date.now();

    const newData = rows.map((row, i) => ({
      ...row,
      created_by: userId,
      id: timestamp + i,
    }));
    for (const row of newData) {
      try {
        if (!validateForm(row)) return;

        const formData = new FormData();
        formData.append("receipt_voucher_no", row.receipt_voucher_no || "");
        formData.append("receipt_number", row.receipt_number || "");
        formData.append("voucher_type", row.voucher_type || "");
        formData.append("project", row.project || "");
        formData.append("proforma_invoice", row.proforma_invoice || "");
        formData.append("description", row.description || "");
        formData.append("invoice_date", row.invoice_date || "");
        formData.append("invoice_number", row.invoice_number || "");
        formData.append("cheque_no", row.cheque_no || "");
        formData.append("party", row.party || "");
        formData.append("bank", row.bank || "");
        formData.append("amount", row.amount || "");
        formData.append("sales_voucher", row.sales_voucher || "");
        formData.append("payment_mode", row.payment_mode || "");
        formData.append("narration", row.narration || "");
        formData.append("created_by", row.created_by);
        // 🔑 File sirf tab append karo jab actual File ho
        if (row.attachment instanceof File) {
          formData.append("attachment", row.attachment);
        }

        await ReceiptVoucherCreate(formData); // JSON nahi, FormData bhejna hai
      } catch (error) {
        console.error("❌ Failed to submit row:", row, error);
      }
    }

    const updatedList = await GetReceiptVoucherList(); // 🔄 Refresh table
    setReceiptVoucher(updatedList.results || []);
    toast.success("Voucher(s) added successfully");
    handleClose();
  };

  const handleEditSave = async () => {
    try {
      if (!validateForm(editFormData)) {
        toast.error("Please fill all required fields.");
        return;
      }
      const formData = new FormData();
      formData.append(
        "receipt_voucher_no",
        editFormData.receipt_voucher_no || ""
      );
      formData.append("receipt_number", editFormData.receipt_number || "");
      formData.append("voucher_type", editFormData.voucher_type || "");
      formData.append("project", editFormData.project || "");
      formData.append("invoice_date", editFormData.invoice_date || "");
      formData.append("invoice_number", editFormData.invoice_number || "");
      formData.append("party", editFormData.party || "");
      formData.append("sales_voucher", editFormData.sales_voucher || "");
      formData.append("proforma_invoice", editFormData.proforma_invoice || "");
      formData.append("description", editFormData.description || "");
      formData.append("amount", editFormData.amount || "");
      formData.append("narration", editFormData.narration || "");
      formData.append("payment_mode", editFormData.payment_mode || "");
      formData.append("cheque_no", editFormData.cheque_no || "");
      formData.append("bank", editFormData.bank || "");
      // 🔑 File sirf tabhi append karo jab vo File ho
      if (editFormData.attachment instanceof File) {
        formData.append("attachment", editFormData.attachment);
      }

      const response = await ReceiptVoucherUpdate(
        editFormData.receipt_voucher_no,
        formData // ab JSON nahi, FormData ja raha hai
      );

      setReceiptVoucher(response);
      setEditModalOpen(false);
      toast.success("Updated successfully!");
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      toast.error("Update failed.");
    }
  };

  const handleDelete = async (voucherId) => {
    try {
      await ReceiptVoucherDelete(voucherId); // DELETE API
      const updatedList = await GetReceiptVoucherList(); // GET latest
      setReceiptVoucher(updatedList); // Update table
      toast.success("Deleted successfully!");
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Delete failed.");
    }
  };

  //===================search=============================
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveReceiptVoucher(
        voucher.receipt_voucher_no, // <-- important change
        approvedById,
        voucher.status,
        remarkInput
      );

      setReceiptVoucher((prev) =>
        prev.map((item) =>
          item.receipt_voucher_no === updated.receipt_voucher_no
            ? updated
            : item
        )
      );

      toast.success("Purchase Voucher approved successfully!");
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve Purchase Voucher.");
    }
  };
  const userRole = localStorage.getItem("role"); // "admin" ya "staff"
  const validateForm = (data) => {
    const errors = {};
    const rowErrs = [];

    // if (!data.invoice_date) errors.invoice_date = "Required";
    // if (!data.invoice_number) errors.invoice_number = "Required";
    if (!data.party) errors.party = "Required";
    if (!data.amount) errors.amount = "Required";
    if (!data.voucher_type) errors.voucher_type = "Required";
    if (!data.payment_mode) errors.payment_status = "Required";

    setFormErrors(errors);
    setRowErrors(rowErrs);

    return (
      Object.keys(errors).length === 0 &&
      rowErrs.every((e) => Object.keys(e).length === 0)
    );
  };
  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  // ⭐ ADD THESE TWO FUNCTIONS AFTER getDateRangeDisplay

  // ✅ Apply Custom Date Range
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  return (
    <>
      <ToastContainer />

      {/* ✅ Responsive Filters */}
      <Box
        display="flex"
        flexWrap={{ xs: "wrap", md: "nowrap" }} // ✅ Mobile mein wrap, Desktop mein nowrap
        alignItems="center"
        sx={{
          mt: -3,
          pt: -3,
          mb: 1,
          width: "100%",
          gap: 2,
        }}
      >
        {/* Status Filter - Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexShrink: 0,
            width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
            justifyContent: { xs: "space-around", md: "flex-start" }, // ✅ Mobile mein center
          }}
        >
          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Pending"
              checked={filters.status === "Pending"}
              onChange={handleSearchChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Pending
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Approved"
              checked={filters.status === "Approved"}
              onChange={handleSearchChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Approved
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Rejected"
              checked={filters.status === "Rejected"}
              onChange={handleSearchChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Rejected
          </label>
        </Box>

        <Box
          sx={{
            width: {
              xs: "100%", // = Grid xs={12}
              sm: "50%", // = Grid sm={6}
              md: "16.66%", // = Grid md={2}  (2/12 = 16.66%)
            },
            // padding: "8px", // Grid item ke gap jaisa
          }}
        >
          <TextField
            label="Date Range"
            value={
              filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(
                  customDateRange.from
                )} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                    ? "Yesterday"
                    : filters.date_range === "this_week"
                      ? "This Week"
                      : filters.date_range === "previous_week"
                        ? "Previous Week"
                        : filters.date_range === "this_month"
                          ? "This Month"
                          : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              "& .MuiInputBase-input": {
                fontSize: "0.8rem",
                padding: "4px 8px",
              },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.7rem",
              },
            }}
          />
        </Box>

        {/* Search Fields Container */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flex: 1,
            width: "100%",
            flexDirection: { xs: "column", md: "row" }, // ✅ Mobile mein column, Desktop mein row
          }}
        >
          <TextField
            label="Receipt Voucher No"
            name="receipt_number"
            size="small"
            value={filters.receipt_number}
            onChange={handleSearchChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" }, // ✅ Desktop mein flex
              width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />

          <TextField
            label="PI NO"
            name="pi_no"
            size="small"
            value={filters.pi_no}
            onChange={handleSearchChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />

          <TextField
            label="Project"
            name="project"
            size="small"
            value={filters.project}
            onChange={handleSearchChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />

          <TextField
            label="Sales voucher no"
            name="sales voucher number"
            size="small"
            value={filters.sales_number}
            onChange={handleSearchChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
        </Box>

        {/* ⭐ REPLACE OLD MENU WITH THIS */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: { width: 350, maxHeight: 500 },
          }}
        >
          {/* Quick Ranges */}
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
          ].map((item) => (
            <MenuItem
              key={item.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: item.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{item.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.7rem" }}
                >
                  {getDateRangeDisplay(item.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* ✅ Custom Date Range - Expandable */}
          <MenuItem
            onClick={() => setShowCustomDateInputs((prev) => !prev)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              {/* From and To Date Inputs Side by Side */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: tempCustomDateRange.to || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              {/* Apply and Cancel Buttons */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "90vh",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              p: 3,
              borderBottom: "1px solid #e0e0e0",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <Typography variant="h6" component="h2" fontWeight={600}>
              Create Receipt Voucher
            </Typography>
          </Box>

          {/* Modal Body - Scrollable Content */}
          <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>
            {rows.map((row, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  backgroundColor: "#f5f7fa",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  p: 3,
                }}
              >
                {/* Row Header */}
                <Typography variant="subtitle1" fontWeight={500} sx={{ mb: 2 }}>
                  Voucher Entry {index + 1}
                </Typography>

                {/* Vertical Form Layout */}
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}
                >
                  {/* Voucher Number */}
                  <TextField
                    fullWidth
                    label="Voucher No."
                    name="receipt_number"
                    value={row.receipt_number || ""}
                    size="small"
                    disabled
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Invoice No."
                    name="invoice_number"
                    value={row.invoice_number || ""}
                    onChange={(e) => handleRowChange(index, e)}
                    size="small"
                    error={!!formErrors.invoice_number}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Invoice Date"
                    name="invoice_date"
                    type="date"
                    value={row.invoice_date || ""}
                    onChange={(e) => handleRowChange(index, e)}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.invoice_date}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                  {/* Voucher Type Selection */}
                  <FormControl component="fieldset">
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        color: "#333",
                        mb: 1,
                      }}
                    >
                      Voucher Type
                    </FormLabel>
                    <RadioGroup
                      row
                      value={row.voucher_type || ""}
                      onChange={(e) =>
                        handleRowChange(index, {
                          target: {
                            name: "voucher_type",
                            value: e.target.value,
                          },
                        })
                      }
                      sx={{
                        flexDirection: "row",
                        gap: 2,
                      }}
                    >
                      <FormControlLabel
                        value="advance"
                        control={<Radio size="small" />}
                        label="Advance/PI"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="sale"
                        control={<Radio size="small" />}
                        label="Sale Voucher"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Conditional Autocomplete - Only show when voucher type is selected */}
                  {row.voucher_type === "advance" && (
                    <Autocomplete
                      options={purchaseLists}
                      getOptionLabel={(option) => option.pi_no || ""}
                      value={purchaseLists.find(
                        (p) => p.invoice_number === row.proforma_invoice
                      )}
                      onChange={(e, newValue) => {
                        handleRowChange(index, {
                          target: {
                            name: "proforma_invoice",
                            value: newValue.invoice_number,
                          },
                        });
                        if (newValue) {
                          handleRowChange(index, {
                            target: {
                              name: "project",
                              value: newValue.project?.id,
                            },
                          });
                          handleRowChange(index, {
                            target: {
                              name: "project_name",
                              value: newValue.project?.project_name,
                            },
                          });
                          handleRowChange(index, {
                            target: {
                              name: "party",
                              value: newValue.project?.party || "",
                            },
                          });

                          handleRowChange(index, {
                            target: {
                              name: "party_name",
                              value: newValue.project?.party_name || "",
                            },
                          });
                          handleRowChange(index, {
                            target: {
                              name: "amount",
                              value: newValue.advance_received.toFixed(2) || "",
                            },
                          });
                        } else {
                          [
                            "division",
                            "division_name",
                            "amount",
                            "project",
                            "project_name",
                          ].forEach((field) => {
                            handleRowChange(index, {
                              target: {
                                name: field,
                                value: "",
                              },
                            });
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Advance/PI"
                          size="small"
                          placeholder="Choose an advance payment..."
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          backgroundColor: "#fff",
                          width: 500,
                        },
                      }}
                    />
                  )}

                  {row.voucher_type === "sale" && (
                    <Autocomplete
                      options={saleList}
                      getOptionLabel={(option) =>
                        option.sales_number || option.name || ""
                      }
                      value={saleList.find(
                        (s) => s.sales_voucher_no === row.sales_voucher
                      )}
                      onChange={(e, newValue) => {
                        handleRowChange(index, {
                          target: {
                            name: "sales_voucher",
                            value: newValue.sales_voucher_no,
                          },
                        });
                        if (newValue) {
                          handleRowChange(index, {
                            target: {
                              name: "project",
                              value: newValue.project,
                            },
                          });
                          handleRowChange(index, {
                            target: {
                              name: "project_name",
                              value: newValue.project_name,
                            },
                          });
                          handleRowChange(index, {
                            target: {
                              name: "party",
                              value: newValue.party || "",
                            },
                          });

                          handleRowChange(index, {
                            target: {
                              name: "party_name",
                              value: newValue.party_name || "",
                            },
                          });
                          handleRowChange(index, {
                            target: {
                              name: "amount",
                              value: newValue.amount.toFixed(2) || "",
                            },
                          });
                        } else {
                          [
                            "division",
                            "division_name",
                            "amount",
                            "project",
                            "project_name",
                          ].forEach((field) => {
                            handleRowChange(index, {
                              target: {
                                name: field,
                                value: "",
                              },
                            });
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Sale Voucher"
                          size="small"
                          placeholder="Choose a sale voucher..."
                        />
                      )}
                      componentsProps={{
                        popper: {
                          sx: {
                            zIndex: 9999,
                            "& .MuiAutocomplete-listbox": {
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: 1,
                              maxHeight: 200,
                              "& .MuiAutocomplete-option": {
                                color: "#000",
                                fontSize: "0.875rem",
                                "&:hover": {
                                  backgroundColor: "#f5f5f5",
                                },
                                "&.Mui-focused": {
                                  backgroundColor: "#e3f2fd",
                                },
                              },
                            },
                          },
                        },
                      }}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          backgroundColor: "#fff",
                        },
                      }}
                    />
                  )}

                  {/* Auto-populated Fields */}
                  {(row.voucher_type === "advance" ||
                    row.voucher_type === "sale") && (
                      <>
                        <TextField
                          fullWidth
                          label="Project"
                          name="project_name"
                          value={row.project_name || ""}
                          size="small"
                          disabled
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "#666",
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        />
                        <TextField
                          fullWidth
                          label="Debtor"
                          name="party_name"
                          value={row.party_name || ""}
                          size="small"
                          disabled
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "#666",
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        />
                        <TextField
                          fullWidth
                          label="Amount"
                          name="amount"
                          value={row.amount || ""}
                          size="small"
                          disabled
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "#666",
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        />
                      </>
                    )}

                  {/* Payment Mode Selection */}
                  <FormControl component="fieldset">
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        color: "#333",
                        mb: 1,
                      }}
                    >
                      Payment Mode
                    </FormLabel>
                    <RadioGroup
                      row
                      value={row.payment_mode || ""}
                      onChange={(e) =>
                        handleRowChange(index, {
                          target: {
                            name: "payment_mode",
                            value: e.target.value,
                          },
                        })
                      }
                      sx={{ gap: 2 }}
                    >
                      <FormControlLabel
                        value="Cash"
                        control={<Radio size="small" />}
                        label="Cash"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="Bank"
                        control={<Radio size="small" />}
                        label="Bank"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="Cheque"
                        control={<Radio size="small" />}
                        label="Cheque/NEFT/RTGS/UPI"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Conditional Payment Details Fields */}
                  {row.payment_mode === "Cash" && (
                    <TextField
                      fullWidth
                      label="Cash Details"
                      name="description"
                      value={row.description || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      placeholder="Enter cash payment details..."
                      multiline
                      rows={2}
                    />
                  )}

                  {row.payment_mode === "Cheque" && (
                    <TextField
                      fullWidth
                      label="Bank Details"
                      name="cheque_no"
                      value={row.cheque_no || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      placeholder="NEFT/RTGS/UPI/Cheque details..."
                      multiline
                      rows={2}
                    />
                  )}

                  {row.payment_mode === "Bank" && (
                    <Autocomplete
                      options={bankDetails}
                      getOptionLabel={(option) =>
                        `${option.account_number} - ${option.bank_name || "Bank"
                        }`
                      }
                      value={bankDetails.find(
                        (option) => option.id === row.bank
                      )}
                      onChange={(e, newValue) =>
                        handleRowChange(index, {
                          target: {
                            name: "bank",
                            value: newValue ? newValue.id : "",
                          },
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Bank Account"
                          size="small"
                          placeholder="Choose bank account..."
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          backgroundColor: "#fff",
                        },
                      }}
                    />
                  )}
                  <TextField
                    fullWidth
                    type="file"
                    name="attachment"
                    id={`attachment-${index}`}
                    onChange={(e) => handleRowChange(index, e)}
                    label="Attachment"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.attachment}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                  {/* Remove Button - Only show if multiple rows */}
                  {rows.length > 1 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 1,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => removeRow(index)}
                        size="small"
                        startIcon={<Close fontSize="small" />}
                        sx={{
                          textTransform: "none",
                          fontWeight: 500,
                          borderRadius: 1.5,
                        }}
                      >
                        Remove Entry
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            ))}
          </Box>

          {/* Modal Footer */}
          <Box
            sx={{
              borderTop: "1px solid #e0e0e0",
              p: 3,
              backgroundColor: "#f8f9fa",
              borderRadius: "0 0 8px 8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Right side buttons */}
            <Box
              sx={{
                borderTop: "1px solid #ddd",
                p: 2,
                display: "flex",
                justifyContent: "flex-end",

                backgroundColor: "#fafafa",
                gap: 1,
              }}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  size="medium"
                  sx={{
                    px: 3,
                    textTransform: "none",
                    fontWeight: 500,
                    borderRadius: 1.5,
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  size="medium"
                  sx={{
                    px: 3,
                    textTransform: "none",
                    fontWeight: 500,
                    borderRadius: 1.5,
                  }}
                >
                  Submit Voucher
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* // Replace your InfiniteScroll section with this: */}
      <InfiniteScroll
        dataLength={receiptVoucher.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more vouchers!</p>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW - Expandable Cards */
          <Box
            sx={{
              bgcolor: "background.paper",
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            {receiptVoucher.map((voucher, index) => (
              <Box key={voucher.id || index}>
                {/* Main Row - Always Visible */}
                <Box
                  onClick={() =>
                    setExpandedReceipt(
                      expandedReceipt === voucher.id ? null : voucher.id
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${voucher.status === "Approved"
                        ? "#4caf50"
                        : voucher.status === "Rejected"
                          ? "#f44336"
                          : "#2196f3"
                      }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    {/* Receipt Number & Amount */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {voucher.receipt_number}
                      </Typography>
                      {/* <Chip
                        label={`₹${
                          voucher.rec_amt?.toLocaleString("en-IN") || 0
                        }`}
                        size="small"
                        color="success"
                        sx={{
                          height: 20,
                          fontSize: "0.7rem",
                          fontWeight: "bold",
                          "& .MuiChip-label": { px: 0.5 },
                        }}
                      /> */}
                    </Box>

                    {/* PI Amount & Debtor */}
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        PI: ₹{voucher.amount?.toLocaleString("en-IN")}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {voucher.company_name?.substring(0, 15) || "N/A"}
                      </span>
                    </Typography>
                  </Box>

                  {/* Expand Icon */}
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedReceipt === voucher.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                {/* Expanded Details */}
                <Collapse
                  in={expandedReceipt === voucher.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${voucher.status === "Approved"
                          ? "#4caf50"
                          : voucher.status === "Rejected"
                            ? "#f44336"
                            : "#2196f3"
                        }`,
                    }}
                  >
                    {/* Details Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      {/* Project */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PROJECT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.project_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Division */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.division_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Payment Mode */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PAYMENT MODE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.payment_mode || "N/A"}
                        </Typography>
                      </Box>

                      {/* PI No */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PI NO
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.pi_no || "N/A"}
                        </Typography>
                      </Box>

                      {/* Sales Voucher No */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          SALES VOUCHER NO
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.sales_number || "N/A"}
                        </Typography>
                      </Box>

                      {/* Invoice Number */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          INVOICE NO
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.invoice_number || "N/A"}
                        </Typography>
                      </Box>

                      {/* Invoice Date */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          INVOICE DATE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {new Date(voucher.invoice_date).toLocaleDateString(
                            "en-GB"
                          )}
                        </Typography>
                      </Box>

                      {/* Debtor - Full Width */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DEBTOR
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.company_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Created By */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CREATED BY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.created_by_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Approved By */}
                      {voucher.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Remarks */}
                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    {/* Action Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {/* Approve - Only Admin */}
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              voucher.status === "Approved"
                                ? "#e8f5e9"
                                : voucher.status === "Rejected"
                                  ? "#ffebee"
                                  : "#e3f2fd",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${voucher.status === "Approved"
                                ? "#4caf50"
                                : voucher.status === "Rejected"
                                  ? "#f44336"
                                  : "#2196f3"
                              }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setPurchaseToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#2196f3",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                voucher.status === "Approved"
                                  ? "#2e7d32"
                                  : voucher.status === "Rejected"
                                    ? "#c62828"
                                    : "#1976d2",
                            }}
                          >
                            {voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      {/* Print & View Buttons */}
                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generateReceiptPdf(voucher);
                          }}
                          sx={{
                            bgcolor: "#fff3e0",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffe0b2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#f57c00" }} />
                        </IconButton>

                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e3f2fd",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#bbdefb",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#1976d2" }}
                              />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e3f2fd",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#bbdefb",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#1976d2" }}
                              />
                            </IconButton>
                          </a>
                        ) : null}
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                {/* Divider between items */}
                <Divider />
              </Box>
            ))}

            {/* Mobile Total Summary */}
            <Box
              sx={{
                p: 2,
                bgcolor: "#e3f2fd",
                position: "sticky",
                bottom: 0,
                borderTop: "2px solid #1976d2",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  Total PI Amount:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  ₹
                  {receiptVoucher
                    .reduce((sum, v) => sum + parseFloat(v.amount || 0), 0)
                    .toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#2e7d32",
                  }}
                >
                  Total Received:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#2e7d32",
                  }}
                >
                  ₹
                  {receiptVoucher
                    .reduce((sum, v) => sum + parseFloat(v.rec_amt || 0), 0)
                    .toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table */
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontSize: "0.75rem",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 3,
                      }}
                    >
                      Approve
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    S.No.
                  </TableCell>
                  <TableCell>Voucher No</TableCell>
                  <TableCell>PI Amt</TableCell>
                  <TableCell>Rec Amt</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Division</TableCell>
                  <TableCell>PI No</TableCell>
                  <TableCell>Sales voucher No</TableCell>
                  <TableCell>Debtor</TableCell>
                  <TableCell>Invoice number</TableCell>
                  <TableCell>Invoice Date</TableCell>
                  <TableCell>Payment Mode</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {receiptVoucher.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": {
                          backgroundColor: "#e3f2fd !important",
                        },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          zIndex: 3,
                        }}
                      >
                        <Checkbox
                          checked={
                            voucher.status === "Approved" ||
                            voucher.status === "Rejected"
                          }
                          onChange={(e) => {
                            setApproveAnchorEl(e.currentTarget);
                            setPurchaseToApprove(voucher);
                          }}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.6)",
                            color:
                              voucher.status === "Approved"
                                ? "green"
                                : voucher.status === "Rejected"
                                  ? "red"
                                  : "grey",
                            "&.Mui-checked": {
                              color:
                                voucher.status === "Approved" ? "green" : "red",
                            },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell>{voucher.receipt_number}</TableCell>
                    <TableCell>
                      {voucher.amount?.toLocaleString("en-IN")}
                    </TableCell>
                    <TableCell>
                      {voucher.rec_amt?.toLocaleString("en-IN")}
                    </TableCell>
                    <TableCell>{voucher.project_name}</TableCell>
                    <TableCell>{voucher.division_name}</TableCell>
                    <TableCell>{voucher.pi_no}</TableCell>
                    <TableCell>{voucher.sales_number}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.company_name || ""} arrow>
                        <span>
                          {truncateText(voucher.company_name || "", 20)}
                        </span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{voucher.invoice_number}</TableCell>
                    <TableCell>
                      {new Date(voucher.invoice_date).toLocaleDateString(
                        "en-GB"
                      )}
                    </TableCell>
                    <TableCell>{voucher.payment_mode}</TableCell>
                    <TableCell>{voucher.created_by_name}</TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                        minWidth: 180,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          color="warning"
                          size="small"
                          onClick={() => generateReceiptPdf(voucher)}
                        >
                          <Print fontSize="small" />
                        </IconButton>
                        <span
                          style={{
                            display: "inline-block",
                            width: 36,
                            textAlign: "center",
                          }}
                        >
                          {typeof voucher.attachment === "string" ? (
                            <a
                              href={`${voucher.attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility transform="scale(0.6)" />
                              </IconButton>
                            </a>
                          ) : voucher.attachment instanceof File ? (
                            <a
                              href={URL.createObjectURL(voucher.attachment)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility transform="scale(0.6)" />
                              </IconButton>
                            </a>
                          ) : (
                            <span
                              style={{ display: "inline-block", width: 24 }}
                            />
                          )}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow
                  sx={{
                    "& td": {
                      backgroundColor: "#E3F2FD !important",
                    },
                  }}
                >
                  <TableCell
                    colSpan={3}
                    align="right"
                    sx={{ fontWeight: "bold !important" }}
                  >
                    Totals:
                  </TableCell>
                  <TableCell>
                    {receiptVoucher
                      .reduce((sum, v) => sum + parseFloat(v.amount || 0), 0)
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                      })}
                  </TableCell>
                  <TableCell>
                    {receiptVoucher
                      .reduce((sum, v) => sum + parseFloat(v.rec_amt || 0), 0)
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                      })}
                  </TableCell>
                  <TableCell colSpan={12} />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setVoucherToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(voucherToDelete);
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
        {/* approve pop */}
      </Popover>
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setPurchaseToApprove(null);
          setRemarkInput("");
          setShowRemarkForIndentId(null);
          setActionType(null);
        }}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            // Desktop
            width: { md: "auto" },
            maxWidth: { md: 1050 },

            // Mobile centering
            "@media (max-width: 899px)": {
              position: "fixed",
              top: "53%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "calc(100% - 32px)",
              maxWidth: "calc(100% - 32px)",
              maxHeight: "85vh",
              overflowY: "auto",
              margin: 0,
              borderRadius: "12px",
            },
          },
        }}
        sx={{
          "& .MuiPopover-paper": {
            "@media (max-width: 899px)": {
              position: "fixed !important",
              top: "53% !important",
              left: "50% !important",
              transform: "translate(-50%, -50%) !important",
              margin: "0 !important",
            },
          },
        }}
      >
        <Box sx={{ p: { xs: 1.5, md: 2 }, minWidth: { xs: "auto", md: 1050 } }}>

          {/* ================= HEADER ================= */}
          <Typography
            variant="subtitle2"
            sx={{
              mb: 1.5,
              textAlign: { xs: "center", md: "left" },
              fontSize: { xs: "1rem", md: "0.875rem" },
              fontWeight: 600,
            }}
          >
            Receipt Voucher Details
          </Typography>

          {/* ================= MOBILE VIEW ================= */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>

            {/* Card 1 - Basic Info */}
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                overflow: "hidden",
                mb: 1.5,
                bgcolor: "#fff",
              }}
            >
              {/* Row 1 */}
              <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0", bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Voucher No.
                  </Typography>
                  <Typography variant="body2" fontWeight={600} color="primary" sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.receipt_number || "-"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Created Date
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.created_at
                      ? dayjs(PurchaseToApprove.created_at).format("DD/MM/YYYY")
                      : "-"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 2 */}
              <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Invoice No
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.invoice_number || "-"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5, bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Receipt Date
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.receipt_date
                      ? dayjs(PurchaseToApprove.receipt_date).format("DD/MM/YYYY")
                      : "-"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 3 */}
              <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0", bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    PI No
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.pi_no || "-"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Receipt Amt
                  </Typography>
                  <Typography variant="body2" fontWeight={700} color="success.main" sx={{ fontSize: "0.85rem" }}>
                    ₹{PurchaseToApprove?.rec_amt || "-"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 4 - Project */}
              <Box sx={{ p: 1.5, borderBottom: "1px solid #e0e0e0" }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                  Project Name
                </Typography>
                <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                  {PurchaseToApprove?.project_name || "-"}
                </Typography>
              </Box>

              {/* Row 5 - Debtor */}
              <Box sx={{ p: 1.5, bgcolor: "#f8f9fa" }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                  Debtor
                </Typography>
                <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                  {PurchaseToApprove?.company_name || "-"}
                </Typography>
              </Box>
            </Box>

            {/* Card 2 - Payment Details */}
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                overflow: "hidden",
                mb: 1.5,
                bgcolor: "#fff",
              }}
            >
              <Box
                sx={{
                  bgcolor: "#e3f2fd",
                  p: 1,
                  textAlign: "center",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <Typography variant="caption" fontWeight={600} color="primary">
                  PAYMENT DETAILS
                </Typography>
              </Box>

              {/* Row 1 */}
              <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Payment Mode
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.payment_mode || "-"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Status
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{
                      fontSize: "0.8rem",
                      color: PurchaseToApprove?.status === "Approved" ? "success.main" :
                        PurchaseToApprove?.status === "Rejected" ? "error.main" : "warning.main"
                    }}
                  >
                    {PurchaseToApprove?.status || "-"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 2 */}
              <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Account No.
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.account_no || "-"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Voucher Type
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {PurchaseToApprove?.voucher_type || "-"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 3 - Narration */}
              <Box sx={{ p: 1.5, bgcolor: "#f8f9fa" }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                  Narration
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                  {PurchaseToApprove?.narration || "-"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* ================= DESKTOP VIEW - UNCHANGED ================= */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Table
              size="small"
              sx={{
                border: "1px solid #000",
                "& td": {
                  borderBottom: "none",
                  padding: "4px 8px",
                  fontSize: "0.8rem",
                },
              }}
            >
              <TableBody>
                {/* ===== ROW 1 ===== */}
                <TableRow>
                  <TableCell>
                    <b>Voucher No.</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.receipt_number}</TableCell>

                  <TableCell>
                    <b>Created Date</b>
                  </TableCell>
                  <TableCell>
                    :{" "}
                    {PurchaseToApprove?.created_at
                      ? dayjs(PurchaseToApprove.created_at).format("DD/MM/YYYY")
                      : "-"}
                  </TableCell>

                  <TableCell>
                    <b>Receipt Amt</b>
                  </TableCell>
                  <TableCell>: ₹{PurchaseToApprove?.rec_amt}</TableCell>
                </TableRow>

                {/* ===== ROW 2 ===== */}
                <TableRow>
                  <TableCell>
                    <b>Invoice No</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.invoice_number}</TableCell>

                  <TableCell>
                    <b>Receipt Date</b>
                  </TableCell>
                  <TableCell>
                    :{" "}
                    {PurchaseToApprove?.receipt_date
                      ? dayjs(PurchaseToApprove.receipt_date).format("DD/MM/YYYY")
                      : "-"}
                  </TableCell>

                  <TableCell>
                    <b>Debtor</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.company_name}</TableCell>
                </TableRow>

                {/* ===== ROW 3 ===== */}
                <TableRow>
                  <TableCell>
                    <b>PI No</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.pi_no || "-"}</TableCell>

                  <TableCell>
                    <b>Project Name</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.project_name}</TableCell>

                  <TableCell />
                  <TableCell />
                </TableRow>

                {/* ===== SEPARATOR ===== */}
                <TableRow>
                  <TableCell colSpan={6} sx={{ borderTop: "2px solid #000" }} />
                </TableRow>

                {/* ===== ROW 4 ===== */}
                <TableRow>
                  <TableCell>
                    <b>Payment Mode</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.payment_mode}</TableCell>

                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.status}</TableCell>

                  <TableCell />
                  <TableCell />
                </TableRow>

                {/* ===== ROW 5 ===== */}
                <TableRow>
                  <TableCell>
                    <b>Account No.</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.account_no || "-"}</TableCell>

                  <TableCell>
                    <b>Voucher Type</b>
                  </TableCell>
                  <TableCell>: {PurchaseToApprove?.voucher_type}</TableCell>

                  <TableCell />
                  <TableCell />
                </TableRow>

                {/* ===== ROW 6 ===== */}
                <TableRow>
                  <TableCell>
                    <b>Narration</b>
                  </TableCell>
                  <TableCell colSpan={5}>: {PurchaseToApprove?.narration}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* ================= REMARK SECTION ================= */}
          {showRemarkForIndentId === PurchaseToApprove?.receipt_voucher_no ? (
            <>
              <Typography variant="body2" sx={{ mb: 1, fontSize: { xs: "0.8rem", md: "0.875rem" } }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>

              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
                multiline
                rows={2}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                  gap: 1,
                  mt: 2,
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  color={actionType === "Approved" ? "success" : "error"}
                  sx={{ minWidth: { xs: "100px", md: "80px" } }}
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }

                    handleApprove({
                      ...PurchaseToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });

                    setApproveAnchorEl(null);
                    setPurchaseToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForIndentId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  sx={{ minWidth: { xs: "100px", md: "80px" } }}
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setPurchaseToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForIndentId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              {/* ================= ACTION BUTTONS ================= */}
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  fontSize: { xs: "0.8rem", md: "0.875rem" },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Do you want to approve or reject this Receipt Voucher?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                  gap: 1,
                  mt: 2,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="success"
                  sx={{
                    minWidth: { xs: "90px", md: "80px" },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                  }}
                  onClick={() => {
                    setShowRemarkForIndentId(PurchaseToApprove?.receipt_voucher_no);
                    setActionType("Approved");
                  }}
                  disabled={PurchaseToApprove?.status === "Approved"}
                >
                  Approve
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  color="error"
                  sx={{
                    minWidth: { xs: "90px", md: "80px" },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                  }}
                  onClick={() => {
                    setShowRemarkForIndentId(PurchaseToApprove?.receipt_voucher_no);
                    setActionType("Rejected");
                  }}
                  disabled={PurchaseToApprove?.status === "Approved"}
                >
                  Reject
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    minWidth: { xs: "90px", md: "80px" },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                  }}
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setPurchaseToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForIndentId(null);
                    setActionType(null);
                  }}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>

      {/* =========================EditModal========================== */}
      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "1400px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box sx={{ p: 2, borderBottom: "1px solid #ddd" }}>
            <Typography variant="h6" component="h2">
              Edit Daily Payment
            </Typography>
          </Box>

          <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>
            {rows.map((row, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  backgroundColor: "#f5f7fa",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  p: 3,
                }}
              >
                {/* Row Header */}
                <Typography variant="subtitle1" fontWeight={500} sx={{ mb: 2 }}>
                  Voucher Entry {index + 1}
                </Typography>

                {/* Vertical Form Layout */}
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}
                >
                  {/* Voucher Number */}
                  <TextField
                    fullWidth
                    label="Voucher No."
                    name="receipt_number"
                    value={editFormData.receipt_number || ""}
                    size="small"
                    disabled
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Invoice No."
                    name="invoice_number"
                    value={editFormData.invoice_number || ""}
                    onChange={handleEditChange}
                    size="small"
                    error={!!formErrors.invoice_number}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Invoice Date"
                    name="invoice_date"
                    type="date"
                    value={editFormData.invoice_date || ""}
                    onChange={handleEditChange}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.invoice_date}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                  {/* Voucher Type Selection */}
                  <FormControl component="fieldset">
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        color: "#333",
                        mb: 1,
                      }}
                    >
                      Voucher Type
                    </FormLabel>
                    <RadioGroup
                      row
                      value={editFormData.voucher_type || ""}
                      onChange={(e, newValue) => {
                        setEditFormData((prev) => ({
                          ...prev,
                          voucher_type: e.target.value,
                        }));
                      }}
                      sx={{
                        flexDirection: "row",
                        gap: 2,
                      }}
                    >
                      <FormControlLabel
                        value="advance"
                        control={<Radio size="small" />}
                        label="Advance/PI"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="sale"
                        control={<Radio size="small" />}
                        label="Sale Voucher"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Conditional Autocomplete - Only show when voucher type is selected */}
                  {editFormData.voucher_type === "advance" && (
                    <Autocomplete
                      options={purchaseLists}
                      getOptionLabel={(option) => option.pi_no || ""}
                      value={purchaseLists.find(
                        (p) =>
                          p.invoice_number === editFormData.proforma_invoice
                      )}
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setEditFormData((prev) => ({
                            ...prev,
                            proforma_invoice: newValue.invoice_number || "",
                            party: newValue.project?.party || "",
                            party_name: newValue.project?.party_name || "",
                            project: newValue.project?.id || "",
                            project_name: newValue.project?.project_name || "",
                            amount: newValue.total_amount.toFixed(2) || "",
                          }));
                        } else {
                          // Reset all when cleared
                          setEditFormData((prev) => ({
                            ...prev,
                            proforma_invoice: "",
                            party: "",
                            party_name: "",
                            project: "",
                            project_name: "",
                            amount: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Advance/PI"
                          size="small"
                          placeholder="Choose an advance payment..."
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          backgroundColor: "#fff",
                          width: 500,
                        },
                      }}
                    />
                  )}

                  {editFormData.voucher_type === "sale" && (
                    <Autocomplete
                      options={saleList}
                      getOptionLabel={(option) =>
                        option.sales_number || option.name || ""
                      }
                      value={saleList.find(
                        (s) => s.sales_voucher_no === editFormData.sales_voucher
                      )}
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setEditFormData((prev) => ({
                            ...prev,
                            sales_voucher: newValue.sales_voucher_no || "",
                            party: newValue.party || "",
                            party_name: newValue.party_name || "",
                            project: newValue.project || "",
                            project_name: newValue.project_name || "",
                            amount: newValue.amount?.toFixed(2) || "",
                          }));
                        } else {
                          // Reset all when cleared
                          setEditFormData((prev) => ({
                            ...prev,
                            sales_voucher: "",
                            party: "",
                            party_name: "",
                            project: "",
                            project_name: "",
                            amount: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Sale Voucher"
                          size="small"
                          placeholder="Choose a sale voucher..."
                        />
                      )}
                      componentsProps={{
                        popper: {
                          sx: {
                            zIndex: 9999,
                            "& .MuiAutocomplete-listbox": {
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: 1,
                              maxHeight: 200,
                              "& .MuiAutocomplete-option": {
                                color: "#000",
                                fontSize: "0.875rem",
                                "&:hover": {
                                  backgroundColor: "#f5f5f5",
                                },
                                "&.Mui-focused": {
                                  backgroundColor: "#e3f2fd",
                                },
                              },
                            },
                          },
                        },
                      }}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          backgroundColor: "#fff",
                        },
                      }}
                    />
                  )}

                  {/* Auto-populated Fields */}
                  {(editFormData.voucher_type === "advance" ||
                    editFormData.voucher_type === "sale") && (
                      <>
                        <TextField
                          fullWidth
                          label="Project"
                          name="project_name"
                          value={editFormData.project_name || ""}
                          size="small"
                          disabled
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "#666",
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        />
                        <TextField
                          fullWidth
                          label="Debtor"
                          name="party_name"
                          value={editFormData.party_name || ""}
                          size="small"
                          disabled
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "#666",
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        />
                        <TextField
                          fullWidth
                          label="Amount"
                          name="amount"
                          value={editFormData.amount || ""}
                          size="small"
                          disabled
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "#666",
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        />
                      </>
                    )}

                  {/* Payment Mode Selection */}
                  <FormControl component="fieldset">
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        color: "#333",
                        mb: 1,
                      }}
                    >
                      Payment Mode
                    </FormLabel>
                    <RadioGroup
                      row
                      value={editFormData.payment_mode || ""}
                      onChange={(e) =>
                        setEditFormData((prev) => {
                          return {
                            ...prev,
                            payment_mode: e.target.value,
                          };
                        })
                      }
                      sx={{ gap: 2 }}
                    >
                      <FormControlLabel
                        value="Cash"
                        control={<Radio size="small" />}
                        label="Cash"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="Bank"
                        control={<Radio size="small" />}
                        label="Bank"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="Cheque"
                        control={<Radio size="small" />}
                        label="Cheque/NEFT/RTGS/UPI"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Conditional Payment Details Fields */}
                  {editFormData.payment_mode === "Cash" && (
                    <TextField
                      fullWidth
                      label="Cash Details"
                      name="description"
                      value={editFormData.description || ""}
                      onChange={handleEditChange}
                      size="small"
                      placeholder="Enter cash payment details..."
                      multiline
                      rows={2}
                    />
                  )}

                  {editFormData.payment_mode === "Cheque" && (
                    <TextField
                      fullWidth
                      label="Bank Details"
                      name="cheque_no"
                      value={editFormData.cheque_no || ""}
                      onChange={handleEditChange}
                      size="small"
                      placeholder="NEFT/RTGS/UPI/Cheque details..."
                      multiline
                      rows={2}
                    />
                  )}

                  {editFormData.payment_mode === "Bank" && (
                    <Autocomplete
                      options={bankDetails}
                      getOptionLabel={(option) =>
                        `${option.account_number} - ${option.bank_name || "Bank"
                        }`
                      }
                      value={bankDetails.find(
                        (option) => option.id === editFormData.bank
                      )}
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setEditFormData((prev) => ({
                            ...prev,
                            bank: newValue.id,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Bank Account"
                          size="small"
                          placeholder="Choose bank account..."
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          backgroundColor: "#fff",
                        },
                      }}
                    />
                  )}
                  <TextField
                    fullWidth
                    type="file"
                    name="attachment"
                    id={`attachment-${index}`}
                    onChange={handleEditChange}
                    label="Attachment"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.attachment}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#666",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                </Box>
              </Box>
            ))}
            <Box
              sx={{
                borderTop: "1px solid #ddd",
                p: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                backgroundColor: "#fafafa",
                gap: 1,
              }}
            >
              <Button
                variant="outlined"
                color="error"
                onClick={() => setEditModalOpen(false)}
                size="small"
                sx={{ px: 2 }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleEditSave}
                size="small"
                sx={{ px: 2 }}
              >
                Update
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* =========================ViewModal========================== */}
      <Modal open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: "1000px",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: 24,
            p: 3,
            overflowY: "auto",
            maxHeight: "90vh",
          }}
        >
          <h2>View Purchase Voucher</h2>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            {Object.entries(viewData).map(([key, value]) => (
              <TextField
                key={key}
                label={key.replace(/_/g, " ").toUpperCase()}
                value={value}
                fullWidth
                InputProps={{ readOnly: true }}
                size="small"
                sx={{ flex: 1, minWidth: 180 }}
                margin="dense"
              />
            ))}
          </Box>

          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button
              onClick={() => setViewModalOpen(false)}
              color="primary"
              variant="contained"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ReceiptVoucher;
